export default __webpack_public_path__ + "static/media/ToyotaVeloz.8d755e7c.png";